import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon.tsx';

// Tela vazia: diz o que aparece aqui e como começar. O mesmo desenho em todo o app.
export function Empty({ icon, title, children, action }: { icon: IconName; title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <span className="es-ic" aria-hidden="true"><Icon name={icon} /></span>
      <b>{title}</b>
      {children && <p>{children}</p>}
      {action && <div className="es-act">{action}</div>}
    </div>
  );
}
